import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { formatCounterAmount } from 'modules/timeoff/components/Leaves/Overview/formatCounterAmount'

import type { Cycle } from 'modules/timeoff/components/Leaves/Overview/NewStatsCounter/allowanceStatUtils'

interface Props {
  amount: number
  nextCycle: Cycle | null | undefined
  isHourlyFixedBalance: boolean
}

const Advance = ({ amount, nextCycle, isHourlyFixedBalance }: Props) => {
  return (
    <Box>
      <Box flexDirection="row" justifyContent="spaceBetween">
        <Text.Normal>{i18n.t('time_off.tooltip_common.advance')}</Text.Normal>
        <Text.Normal>{formatCounterAmount(amount, isHourlyFixedBalance)}</Text.Normal>
      </Box>
      <Box flexDirection="row" justifyContent="flexStart">
        <Text.Normal size="200">
          {i18n.t('time_off.tooltip_common.generated_on', {
            cycle: nextCycle?.yearLabel,
          })}
        </Text.Normal>
      </Box>
    </Box>
  )
}

export default observer(Advance)
